module.exports = __webpack_public_path__ + "img/aegeo_logo_blue.0246730d.jpg";